<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="送料明细"
      width="1000px"
      class="feedEdit"
      @close="$reset('form')">
    <el-form ref="form" :model="model" class="form" label-width="100px">
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectInventory.open(model.rowInfo)"> 添加 </el-button>
      <el-table class="tableBox" :data="model.outStockBillDetailList" border>
        <el-table-column prop="materialNo" align="center" label="物料编号" width="140"/>
        <el-table-column
            prop="materialName"
            align="left"
            label="物料名称"
            min-width="300"
            show-overflow-tooltip/>
        <el-table-column
            prop="locationName"
            align="left"
            label="库位名称"
            width="120"
            show-overflow-tooltip/>
        <el-table-column prop="originQuantity" align="center" label="库存数量" width="80"/>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <el-table-column prop="price" align="center" label="单价" width="60"/>
        <el-table-column align="center" label="数量" width="120" prop="quantity">
          <template slot-scope="scope">
            <el-form-item>
              <el-input v-model="scope.row.quantity" placeholder="请输入" @input="changeQuantity(scope.row)"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="120"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <inventory-select ref="selectInventory" @select="selectInventory"/>
  </el-dialog>
</template>

<script>
  import InventorySelect from "./InventorySelect";
  export default {
    name: "FeedEdit",
    components: { InventorySelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        model: {
          outStockBillDetailList: [],
          rowInfo: "",
        },
      };
    },
    methods: {
      open(row) {
        this.model.rowInfo = row;
        this.dialogVisible = true;
      },

      // 选择库存
      selectInventory(row) {
        const arr = this.model.outStockBillDetailList.filter((item) => item.materialNo === row.materialNo && item.locationId === row.locationId);
        if (arr.length) {
          this.$confirm("该物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const materialItem = {
          materialSn: row.materialSn,
          unitId: row.unitId,
          unitName: row.unitName,
          materialId: row.materialId,
          materialNo: row.materialNo,
          materialName: row.materialName,
          quantity: "",
          price: row.price,
          locationId: row.locationId,
          locationName: row.locationName,
          note: "",
          originQuantity: row.quantity,
        };
        this.model.outStockBillDetailList.push(materialItem);
      },

      // 输入数量
      changeQuantity(row) {
        if (+row.quantity > +row.originQuantity) {
          this.$confirm("超出库存数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },

      // 删除物料
      deleteMaterial(index) {
        this.model.outStockBillDetailList.splice(index, 1);
      },

      // 送料
      handleSubmit() {
        if (!this.model.outStockBillDetailList.length) {
          this.$confirm("明细不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const arr = this.model.outStockBillDetailList.filter((item) => !item.quantity);
        if (arr.length) {
          this.$confirm("数量不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;
        this.model.rowInfo.outStockBillDetailList = this.model.outStockBillDetailList;
        this.$http
          .save("basic", "workCenters/location/materialTransfer", this.model.rowInfo)
          .then((resp) => {
            this.submitLoading = false;
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("操作成功");
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss">
.feedEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.feedEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.feedEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.feedEdit .el-divider--horizontal {
  margin: 10px 0;
}

.feedEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
